import { createApp } from "vue/dist/vue.esm-bundler.js";

class ElementorService {
    constructor(regComponents) {
        const wrapper = document.getElementById("app");

        if (!wrapper || !("elementorEditor" in window && window.elementorEditor == true)) {
            return;
        }

        new MutationObserver((mutations) => {
            console.log("🐌 Elementor update detected ...");
            mutations.forEach((mutation) => {
                if (mutation.addedNodes) {
                    mutation.addedNodes.forEach((node) => {
                        if (
                            node.nodeType === 1 &&
                            node.matches(".elementor-widget-container:not(.x-loaded)")
                        ) {
                            const widget = createApp({});
                            regComponents(widget);
                            widget.mount(node);
                            node.classList.add("x-loaded");
                        }
                    });
                }
            });
        }).observe(wrapper, {
            childList: true,
            subtree: true,
        });
    }
}

export default ElementorService;
